import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    meta: {
        pageNumber: 1,
        pageSize: 20,
        itemTotal: 0
    },
    list: [],
    reports: [],
    selectedDeal: {
        deal: {
            _id: undefined
        },
        files: []
    },
    dealAdded: false,
    dealUpdated: false,
    dealRemoved: false,
    dealsFields: []
};

const dealsSlice = createSlice({
    name: 'deals',
    initialState,
    reducers: {
        getDeals(state, action) {
            state.list = action.payload.deals;
            state.meta = action.payload.meta
        },
        getDealsReport(state, action) {
            state.reports = action.payload;
        },
        getDealsById(state, action) {
            state.selectedDeal = action.payload;
        },
        addDeals(state, action) {
            state.dealAdded = true
        },
        updateDeals(state, action) {
            state.dealUpdated = true
        },
        removeDeals(state, action) {
            state.dealRemoved = true
        },
        getDealFields(state, action) {
            state.dealsFields = action.payload;
        },
        updateDealFields(state, action) {
            state.dealUpdated = true
        },
        reset: (state) => initialState,
        logout: (state) => initialState,
    },
});

export const dealsActions = dealsSlice.actions;
export default dealsSlice;
